module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p25-1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('h2', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch6",
      "id": "rch6"
    }
  }, [_c('b', [_vm._v("Always Spit After a Fisherman")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub2"
  }, [_c('b', [_vm._v("Want people from other countries to think you’re polite? Of course you do. So here are a few BRI tips about what’s considered good manners around the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p25-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p25-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN JAPAN:")])]), _vm._v(" Wear a surgical mask in public if you have a cold.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN SWITZERLAND:")])]), _vm._v(" Buy wine for your table if you drop your bread in the fondue.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN ITALY:")])]), _vm._v(" Don’t allow a woman to pour wine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN SAMOA:")])]), _vm._v(" Spill a few drops of kava, the national beverage, before drinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN BELGIUM AND LUXEMBOURG:")])]), _vm._v(" Avoid sending a gift of chrysanthemums. They are a reminder of death.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN SWEDEN:")])]), _vm._v(" Wait until you’re outside your guest’s house before putting your coat on.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN JORDAN:")])]), _vm._v(" Leave small portions of food on your plate. Also, refuse seconds at least twice before accepting.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN GREECE:")])]), _vm._v(" Cheerfully participate in folk dancing if invited.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN PORTUGAL:")])]), _vm._v(" Signal you enjoyed a meal by kissing your index finger and then pinching your earlobe.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN CHINA:")])]), _vm._v(" Decline a gift a few times before accepting. Use both hands to give or receive one.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN KOREA:")])]), _vm._v(" Allow others to pass between you and the person you are conversing with. Don’t make anyone walk behind you.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN IRAN:")])]), _vm._v(" Shake hands with children. (It shows respect for their parents.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN SPAIN:")])]), _vm._v(" Say “buen provecho” to anyone beginning a meal.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN FINLAND:")])]), _vm._v(" If you pass the salt at the dinner table, don’t put it in anyone’s hand—put the salt shaker down and let them pick it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN FIJI:")])]), _vm._v(" Fold your arms behind you when conversing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('b', [_c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "lyell"
  }, [_vm._v("IN NORWAY:")])]), _vm._v(" When a fisherman walks by, spit after him. It’s a way of wishing him good luck.")])]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("MARK WAHLBERG HAS THREE NIPPLES.")])])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f468ccb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013_Chapter6.vue
// module id = 96
// module chunks = 0